import React from 'react';
import { Container } from 'react-bootstrap';
import SprintSectionHeader from './sprint-section-header';

export default function SprintTags({ 
    label, 
    titlePrefix, 
    highlightText, 
    titleSuffix, 
    subtitle, 
    items, 
    variant = 'problem', // 'problem' (cross icon) or 'check' (check icon)
}) {
    const isCheck = variant === 'check';
    const tagClass = isCheck ? 'check-tag' : 'problem-tag';
    
    // Cross SVG for problem, Check SVG for check variant
    const icon = isCheck ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
    ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    );

    return (
        <section className={`sprint-problems`}>
            <Container>
                <SprintSectionHeader 
                    label={label}
                    titlePrefix={titlePrefix}
                    highlightText={highlightText}
                    titleSuffix={titleSuffix}
                    subtitle={subtitle}
                    center={true}
                />
                
                <div className="sprint-problems-wrapper">
                    <div className="sprint-problem-tags sprint-reveal">
                        {items && items.map((item, idx) => (
                            <div className={`sprint-problem-tag ${tagClass} sprint-delay-${(idx % 6) + 1}`} key={idx}>
                                <span className="tag-icon">{icon}</span>
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </Container>
        </section>
    );
}
